import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Grid, MenuItem, Paper, Radio, RadioGroup, Select, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography }  from '@mui/material';
import { Autocomplete, Stack } from '@mui/material';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import MissionOrderService from '../../../services/MissionOrderService';
import VehicleService from '../../../services/VehicleService';
import Table from '../../../components/Table';

const MissionVehicleDetailAdd = (props) => {
    const openDialog = props.openDialog;
    const closeDialog = props.closeDialog;
    const missionnary = props.missionnary;
    const [ drivers, setDrivers ] = useState([]);
    const [ vehicles, setVehicles ] = useState([]); 
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [transportData, setTransportData] = useState([]);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        async function fetchDrivers() {
          setOpenLoadingSimpleBackdrop(true);
          try {
            const result = await VehicleService.getDriversMission();
            if (result?.data) {
              setDrivers(result.data);
            }
          } catch (error) {
            console.error("Error fetching drivers:", error);
          } finally {
            setOpenLoadingSimpleBackdrop(false);
          }
        }
    
        async function fetchVehicle() {
          setOpenLoadingSimpleBackdrop(true);
          try {
            const result = await VehicleService.getAllVehicles();
            if (result?.data) {
             setVehicles(result.data);
            }
          } catch (error) {
            console.error("Error fetching drivers:", error);
          } finally {
            setOpenLoadingSimpleBackdrop(false);
          }
        }
    
        fetchVehicle();
        fetchDrivers();
      }, []);

    const handleClose = (event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        closeDialog();
      };

    return (
        <div>
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
        <Dialog open={openDialog} onClose={handleClose} 
        disableEscapeKeyDown 
        maxWidth="md"
        fullWidth 
        sx={{ "& .MuiDialog-paper": { width: "80vw", maxWidth: "none" } }} >
          <DialogTitle id="form-dialog-title" color="primary" >{"Gestion transport / ref"}</DialogTitle>
          <DialogContent >
            <DialogContentText id="alert-dialog-description">
            {
              rows && rows.length > 0 ? (
           
            <Table size="small" aria-label="sous-tableau" sx={{ marginTop: "1%", marginBottom: "2%", boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;"}}>
                                      <TableHead>
                                      <TableRow sx={{fontStyle: "bold"}}>
                                        <TableCell>Type</TableCell>
                                        <TableCell>Véhicule</TableCell>
                                        <TableCell>Chauffeur</TableCell>
                                        <TableCell>Chef de bord</TableCell>
                                        <TableCell>Missionnaire</TableCell>
                                      </TableRow>
                                      </TableHead>
                                      <TableBody>
                                     {  rows.map((items, index) => (
                                      <TableRow key={index}>
                                        <TableCell>
                                        </TableCell>
                                        <TableCell>
                                        </TableCell>
                                        <TableCell>
                                        </TableCell>
                                        <TableCell>
                                        </TableCell>
                                        <TableCell>
                                        </TableCell>
                                        <TableCell>
                                        </TableCell>
                                      </TableRow>
                                      ))}
                                      </TableBody>
                                    </Table>
              ) : null
            }
              <Grid item xs={4}>
                Type voiture
                </Grid>
              <Grid item xs={8}>
              <FormControl fullWidth variant="outlined" size="small">

              <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    label="direction"
                    // value={missionData.transport}
                    name="transport_type"
                    // onChange={handleChange}
                  >
                    <MenuItem value="voiture FID">Voiture FID</MenuItem>
                    <MenuItem value="voiture location">Voiture location</MenuItem>
                  </Select>
              </FormControl>
               </Grid>
              
                    <Grid item xs={4}>
                <Typography variant="body1" align="left" >Moyen de déplacement </Typography>
              </Grid>
              <Grid item xs={8}>
                <FormControl fullWidth variant="outlined" size="small">
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    label="direction"
                    // value={missionData.transport}
                    name="transport_type"
                    // onChange={handleChange}
                  >
                    <MenuItem value="A Déterminer">À déterminer</MenuItem>
                    <MenuItem value="voiture FID">Voiture FID</MenuItem>
                    <MenuItem value="voiture location">Voiture location</MenuItem>
                    <MenuItem value="Avion">Avion</MenuItem>
                    <MenuItem value="Moto">Moto</MenuItem>
                    <MenuItem value="Bateau">Bateau</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
               
          
              <Grid item xs={4}>
                <Typography variant="body1" align="left" >Slectionner un voiture </Typography>
              </Grid>
              <Grid item xs={8}>
              <FormControl fullWidth variant="outlined" size="small">
              <Autocomplete multiple id="tags-outlined"
                                      options={vehicles}
                                      getOptionLabel={(option) => `${option.vhc_imm} (${option.vhc_place} places)`}
                                      filterSelectedOptions
                                      // onChange={(event, value) => handleChangeParticipant(event, value, index)}
                                      // value={items.particip}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          fullWidth
                                          id="outlined-basic"
                                          size="small"
                                          variant="outlined"
                                        />
                                      )}
                     />
              </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1" align="left" >Chauffeur </Typography>
              </Grid>
              <Grid item xs={8}>
              <FormControl fullWidth variant="outlined" size="small">
              <Autocomplete multiple id="tags-outlined"
                                      options={drivers}
                                      getOptionLabel={(option) => option.name}
                                      filterSelectedOptions
                                      // onChange={(event, value) => handleChangeParticipant(event, value, index)}
                                      // value={items.particip}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          fullWidth
                                          id="outlined-basic"
                                          size="small"
                                          variant="outlined"
                                        />
                                      )}
                                    />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1" align="left" >Chef de bord </Typography>
              </Grid>
            <Grid item xs={8}>
            <Autocomplete multiple id="tags-outlined"
                                  options={missionnary || []}
                                  getOptionLabel={(option) => option.nom}
                                  filterSelectedOptions
                                  // onChange={(event, value) => handleChangeMissionary(event, value, index)}
                                  // value={items.user_id}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      id="outlined-basic"
                                      size="small"
                                      variant="outlined"
                                    />
                                  )}
                                />
                </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button
                  variant="contained"
                //   color="secondary"
                  style={{ marginBottom: "40px", marginRight: '30px', }}
                  onClick={closeDialog}
                  autoFocus
                >
                  Annuler
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginRight: '30px', marginBottom: "40px" }}
                //   onClick={handleSubmit}
                  autoFocus
                >
                  Enregistrer
                </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
    }

export default MissionVehicleDetailAdd;